<template>
<div class="chapter">
<div class="inner_page">
<p class="c">Seduced by Shark Shifters IV: Mark’s Midlife</p>
<p class="c1">By Rafe Jadison</p>
<p class="c1">Copyright 2020 Rafe Jadison</p>
<p class="c1">Smashwords Edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue?7f7b6c29